import { Button, Stack } from "@mui/material";
import { useState } from "react";
import FeedbackModal from "./FeedbackModal";

interface IProps {
  url: string;
  destinationEmail: string;
  subject: string;
  placeholder?:  string;
  buttonText: string;
}

export default function FeedbackButton({ url, destinationEmail, subject, placeholder, buttonText }: IProps) {
  const [openFeedback, setOpenFeedback] = useState(false);
  return (
    <Stack>
      <Button
        size="large"
        onClick={() => setOpenFeedback(true)}
        color="primary"
        variant="outlined"
        sx={{
          position: "fixed",
          right: -55,
          top: "50%",
          zIndex: 1300,
          boxShadow: 3,
          minWidth: 160,
          minHeight: 50,
          transform: "rotate(270deg)",
        }}
      >
       {buttonText}
      </Button>
      {openFeedback && (
        <FeedbackModal
          onClose={() => setOpenFeedback(false)}
          open={openFeedback}
          url={url}
          destinationEmail={destinationEmail}
          subject={subject}
          placeholder={placeholder}
        />
      )}
    </Stack>
  );
}
